import { commentQueryKeys } from './commentQueryKeys.js';

const commentQueryPredicates = {
  commentByResourceId: (query, resourceId) => {
    return query.queryKey[0] === commentQueryKeys.resourceComments()[0] && query.queryKey[1] === resourceId;
  }
};

export { commentQueryPredicates };
//# sourceMappingURL=commentQueryPredicates.js.map
